import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PapiAuthService } from '../services/papi-auth.service';

export const loginRedirectGuard: CanActivateFn = () => {
  const authService = inject(PapiAuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    router.navigate(['/home']);
    return false;
  }
  return true;
};